import PagePlaceholder from '@/components/PagePlaceholder';

export default function AutomationPage() {
  return (
    <PagePlaceholder
      title="Automation"
      subtitle="Intelligent workflows that reduce manual work and accelerate operations."
    />
  );
}